import type { RoleModuleDto } from '~/core/services/ApiClient'
import { PermissonEnum } from '~/constants/systemEnum'

/** Allow thô trước khi trừ Deny — khớp PermissionBitmaskHelper.ToAllowMask. */
export function toRawAllowMask(moduleData: RoleModuleDto | undefined): number {
  if (!moduleData) return 0
  if (moduleData.isFull) return PermissonEnum.Full
  if (moduleData.allow && moduleData.allow > 0) return moduleData.allow
  return (moduleData.permissions ?? []).reduce(
    (acc, p) => acc | (p.permission ?? 0),
    0,
  )
}

/**
 * Allow hiệu lực sau Deny.
 * IsFull → Deny không áp dụng (khớp PermissionResolver.ResolveMask backend).
 */
export function getEffectiveAllowMask(moduleData: RoleModuleDto | undefined): number {
  if (!moduleData) return 0
  if (moduleData.isFull) return PermissonEnum.Full
  const deny = moduleData.deny ?? 0
  return toRawAllowMask(moduleData) & ~deny
}

export function hasEffectivePermission(
  moduleData: RoleModuleDto | undefined,
  permission: number,
): boolean {
  const effective = getEffectiveAllowMask(moduleData)
  if (effective === 0) return false

  if (permission === PermissonEnum.Allow) return true

  if ((effective & PermissonEnum.Full) === PermissonEnum.Full) return true

  return (effective & permission) === permission
}
